import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslations } from 'use-intl';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/app/ui/components/breadcrumb';
import { Header, HeaderBackButton, HeaderSidebarTrigger } from '@/app/ui/components/header';
import { HugeiconsIcon } from '@hugeicons/react';
import { AiBrain02Icon } from '@hugeicons/core-free-icons';
import { MainScrollArea } from '@/app/ui/components/main';
import NewBulkTenderFeedbackForm from '@/app/components/features/tenderFeedbacks/NewBulkTenderFeedbackForm';

export const Route = createFileRoute('/_authed/(organization)/_layout/knowledge-base/new-feedback')(
  {
    component: RouteComponent,
  },
);

function RouteComponent() {
  const t = useTranslations('components.tenderFeedbacksKnowledgeBase');
  const tPage = useTranslations('pages.tenderFeedbacks');
  const tKnowledgeBase = useTranslations('pages.knowledgeBase');
  const navigate = useNavigate();

  return (
    <>
      <Header>
        <HeaderBackButton />
        <HeaderSidebarTrigger />
        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink to="/knowledge-base">
                <HugeiconsIcon icon={AiBrain02Icon} />
                {tKnowledgeBase('breadcrumbs.knowledgeBase')}
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbPage>{tPage('breadcrumbs.addNew')}</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
      </Header>
      <MainScrollArea>
        <NewBulkTenderFeedbackForm
          onSuccess={() => {
            navigate({ to: '/knowledge-base' });
          }}
          onCancel={() => navigate({ to: '/knowledge-base' })}
        />
      </MainScrollArea>
    </>
  );
}
